module.exports = __webpack_public_path__ + "static/media/paper_covid_tests_getty_mobile.c022f15a.jpg";